import { render } from "./GeneralRequest.vue?vue&type=template&id=89e0e146&scoped=true"
import script from "./GeneralRequest.vue?vue&type=script&lang=js"
export * from "./GeneralRequest.vue?vue&type=script&lang=js"

import "./GeneralRequest.vue?vue&type=style&index=0&id=89e0e146&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89e0e146"]])

export default __exports__